//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import $ from "jquery";

import { sessionFetch } from '@utils/sessionFetch';
import curalateModule from 'app/curalate.module';

async function loginToFreshdesk(hostUrl?: string) {

  const params = $.param({ host_url: hostUrl });
  const res = await sessionFetch(`/api/freshdesk/login-url?${params}`);

  const url = await res.json() as { url: string };

  location.assign(url.url);
}

interface IFreshdeskLoginParams {
    // The Freshdesk hostname to redirect the user to
    // e.g. help.curalate.com
  host_url?: string;
}

curalateModule.component('freshdeskLoginPage', {
  controller: [
    '$stateParams',
    (
            $stateParams: IFreshdeskLoginParams,
        ) => ({
          $onInit: () => loginToFreshdesk($stateParams.host_url),
        }),
  ],
});
